export default {
  spaceBetweenElements: 16,
  spaceBetweenTitleAndDescription: 6
};